// extracted by mini-css-extract-plugin
export var dropZoneViewServiceIcon = "drop-zone-view__service-icon_R3x5dzFr_UwVr2bh92V4";